<div class="slider-container">
  <!-- Slides -->
  <div
    class="slide"
    *ngFor="let image of sliderData; let i = index"
    [class.active]="i === currentIndex"
  >
    <img [src]="image.url" [alt]="image.alt" />
    <div class="caption-container">
      <h4 class="caption">{{ image.caption }}</h4>
      <h6 class="sub-caption">{{ image.subCaption }}</h6>
    </div>
  </div>

  <!-- Controls -->
  @if(showButtons){
  <button class="prev" (click)="prevSlide()">&#10094;</button>
  <button class="next" (click)="nextSlide()">&#10095;</button>
  }

  <!-- Indicators -->
  <div class="indicators">
    <span
      *ngFor="let image of sliderData; let i = index"
      [class.active]="i === currentIndex"
      (click)="goToSlide(i)"
    ></span>
  </div>
</div>
